import type { JobState } from "@eagledispatch/shared";

/** State → CSS class suffix (see App.css `.status-tag--*`). */
const STATE_CLASS: Record<JobState, string> = {
  NEW: "new",
  IN_PROGRESS: "in-progress",
  FINISHED: "finished",
  REVIEWED: "reviewed",
  CANCELLED: "cancelled",
  PAUSED: "paused",
};

const STATE_LABEL: Record<JobState, string> = {
  NEW: "NEW",
  IN_PROGRESS: "IN PROGRESS",
  FINISHED: "FINISHED",
  REVIEWED: "REVIEWED",
  CANCELLED: "CANCELLED",
  PAUSED: "PAUSED",
};

export default function StatusTag({ state }: { state: JobState }) {
  return (
    <span className={`status-tag status-tag--${STATE_CLASS[state]}`}>
      {STATE_LABEL[state]}
    </span>
  );
}
